import PropTypes from "prop-types"
import React from "react"

import { useTracker } from "src/hooks/use_tracker"

const formatDate = (value) => {
  if (!value) return "—"
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return "—"
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  })
}

const formatAmount = (amount, currency) => {
  if (amount == null) return "—"
  const cents = Number(amount)
  if (Number.isNaN(cents)) return "—"
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: (currency || "USD").toUpperCase(),
    }).format(cents / 100)
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency || ""}`.trim()
  }
}

const InvoicesTable = ({ invoices }) => {
  const tracker = useTracker()

  const handlePdfPressed = (invoice) => {
    tracker.trackEvent("manage_subscriptions:invoice_pdf_pressed", {
      invoice_uuid: invoice.uuid,
      invoice_number: invoice.number,
    })
  }

  return (
    <section className="rounded border border-gray-200 bg-white px-5 pb-5 pt-2">
      <h2 className="mb-3 text-lg font-semibold">Recent invoices</h2>
      {invoices.length === 0 ? (
        <p className="text-gray-600">No invoices yet.</p>
      ) : (
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs uppercase text-gray-500">
              <th className="py-2 pr-4">Invoice</th>
              <th className="py-2 pr-4">Date</th>
              <th className="py-2 pr-4">Amount</th>
              <th className="py-2 pr-4">Status</th>
              <th className="py-2">PDF</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.uuid} className="border-b border-gray-100">
                <td className="py-2 pr-4">{invoice.number || invoice.uuid}</td>
                <td className="py-2 pr-4">
                  {formatDate(invoice.invoice_date)}
                </td>
                <td className="py-2 pr-4">
                  {formatAmount(invoice.total_cents, invoice.currency)}
                </td>
                <td className="py-2 pr-4">{invoice.status || "—"}</td>
                <td className="py-2">
                  {invoice.pdf_url ? (
                    <a
                      href={invoice.pdf_url}
                      target="_blank"
                      rel="noreferrer"
                      onClick={() => handlePdfPressed(invoice)}
                      className="text-blue-600 hover:underline"
                    >
                      View
                    </a>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  )
}

InvoicesTable.propTypes = {
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      number: PropTypes.string,
      invoice_date: PropTypes.string,
      total_cents: PropTypes.number,
      currency: PropTypes.string,
      status: PropTypes.string,
      pdf_url: PropTypes.string,
    })
  ).isRequired,
}

export default InvoicesTable
